export const aboutData = {
    title: "Who I am",
    description1: "I'm a android developer based in Gurgaon, Haryana.",
    description2: "I'm currently pursuing my B.Tech. major in Computer Science Engineering from Dronacharya College of Engineering. I love problem solving. Besides that I enjoy coding. I love to learn and explore new arenas.",
    image: 2
}